import { ClubsService } from './../clubs.service';
import { Router } from '@angular/router';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { Club } from '../club.model';
import { ToastrManager } from 'ng6-toastr-notifications';

@Component({
  selector: 'app-clubs-detail',
  templateUrl: './clubs-detail.component.html',
  styleUrls: ['./clubs-detail.component.css']
})
export class ClubsDetailComponent implements OnInit,OnDestroy {

  public club:Club;

  private detailSubscription:Subscription;

  constructor(public clubServ: ClubsService,public navigator:Router,public toastr:ToastrManager) {
    this.detailSubscription=new Subscription();
   }

  ngOnDestroy(): void {
    if(this.detailSubscription) return

    this.detailSubscription.unsubscribe();
  }

  ngOnInit() {
    this.detailSubscription.add(this.clubServ.getObject('club').subscribe(club=>this.club=club));
  }

  editClub(club:Club){
    this.navigator.navigate(['/admin/clubs/edit']).then(()=>{
      this.clubServ.setObject(club,'club');
    })
  }

  updateImageProfile(event:any,club:any){
    if(confirm('Deseja realmente actualizar o Logotipo?')){

            // criando um formData
            let formData = new FormData();


            // convertendo o formpartner para formData
            formData.append('id', club['id'])
      
            // Anexando a imagem
            if(event.target.files[0])
              formData.append('picture', event.target.files[0], event.target.files[0].name)

      // save image
      this.clubServ.updateImageWithNoData(formData,'club')
      .subscribe(message=>{
        this.toastr.successToastr(message)
      })

    }
  }

}
